




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { FullWidthTextBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import tableHtmlService from './tableHtml.service';
import { hexToRgbValues, luma } from '@/core/color/color.service';
import tailwind from '@/styling/tailwind.config';

@Component({
    components: { SmartHeadline }
})
export default class FullWidthTextBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: FullWidthTextBlockViewModel;

    @Prop({
        required: true,
        type: Boolean
    }) isFirstBlock!: boolean;

    @Prop({
        required: false,
        type: String
    }) parentAlias!: string;

    get backgroundColor() {
        return this.content.customBackgroundColor
            ? this.content.customBackgroundColor
            : this.content.backgroundColor ? '#' + this.content.backgroundColor : undefined;
    }

    get textColor() {
        if (!this.backgroundColor) return undefined;
        const { red, green, blue } = hexToRgbValues(this.backgroundColor);
        const isDarkBackground = luma(red, green, blue) <= 0.5;
        return isDarkBackground ? tailwind.theme.colors.white : tailwind.theme.colors.black;
    }

    get style(): Partial<CSSStyleDeclaration> {
        return {
            backgroundColor: this.backgroundColor,
            color: this.textColor
        };
    }

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    bodyText(html: string): string {
        return tableHtmlService.wrapTableInOuterDivs(html);
    }

    $refs!: Vue['$refs'] & {
        htmlContent: HTMLElement
    }

    mounted() {
        tableHtmlService.registerTableOverflow(this.$refs.htmlContent);
    }

    beforeDestroy() {
        tableHtmlService.unregisterTableOverflow(this.$refs.htmlContent);
    }
}
